import { render, staticRenderFns } from "./LocalProfileView.vue?vue&type=template&id=167fd6b0&"
import script from "./LocalProfileView.vue?vue&type=script&lang=js&"
export * from "./LocalProfileView.vue?vue&type=script&lang=js&"
import style0 from "./LocalProfileView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports